import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrFileIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M5.1 8H10.8C11.2 8 11.5 8.3 11.5 8.7C11.5 9.1 11.2 9.4 10.8 9.4H5.1C4.7 9.4 4.4 9.1 4.4 8.7C4.4 8.3 4.7 8 5.1 8ZM8.9 11H5.1C4.7 11 4.4 11.3 4.4 11.7C4.4 12.1 4.7 12.4 5.1 12.4H8.9C9.3 12.4 9.6 12.1 9.6 11.7C9.6 11.3 9.3 11 8.9 11ZM13.9 4.7V13.7C13.9 14.6 13.1 15.4 12.2 15.4H3.7C2.8 15.4 2 14.6 2 13.7V1.7C2 0.8 2.8 0 3.7 0H8.9C9 0 9 0 9.1 0C9.2 0 9.3 0.1 9.3 0.1L13.6 4.1C13.7 4.2 13.7 4.2 13.8 4.3C13.9 4.5 13.9 4.6 13.9 4.7ZM9.6 3.7C9.6 3.9 9.7 4 9.9 4H11.4L9.6 2.3V3.7ZM12.5 5.4H9.9C9 5.4 8.2 4.6 8.2 3.7V1.4H3.7C3.5 1.4 3.4 1.5 3.4 1.7V13.7C3.4 13.9 3.5 14 3.7 14H12.2C12.4 14 12.5 13.9 12.5 13.7V5.4Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrFileIconComponent;
